'use client';
import React from 'react';
import { Box, Stack } from '@mui/material';
import Image from 'next/image';
import { Mobile } from '@components/Mobile';
import { Desktop } from '@components/Desktop';
import CommonContainer from '@components/CommonContainer';
import ReactHtmlParser from '@libs/reactHtmlParser';
import ParallaxText from '@components/ParallaxText';
import { url } from 'inspector';
import cn from './style.module.scss';
export default function HouseDiscover(props: any) {
  const { t } = props;
  return (
    <Stack component="section" className={cn.beachHouseDiscover}>
      <Box
        className={cn.beachDiscoverInner}
        sx={{
          backgroundImage: `url(${props.beachHouseDiscoverBackgroundImage.url})`,
        }}
      >
        <CommonContainer maxWidth={{ xs: '100%', md: '1320px' }} flexGrow={1}>
          <Box className={cn.beachDiscoverBody}>
            <Box className={cn.beachDiscoverContent}>
              <Box className={cn.beachDiscoverContent__heading}>
                <ParallaxText
                  variant="h2"
                  animationType="slideInBottom"
                  animationDuration={500}
                >
                  {ReactHtmlParser(t['beachHouseDiscoverHeading'])}
                </ParallaxText>
              </Box>
              <Box className={cn.beachDiscoverContent__description}>
                <ParallaxText
                  variant="p"
                  animationType="slideInBottom"
                  animationDuration={500}
                >
                  {ReactHtmlParser(t['beachHouseDiscoverContent'])}
                </ParallaxText>
              </Box>
            </Box>
          </Box>
        </CommonContainer>
      </Box>
    </Stack>
  );
}
